import { Map } from 'immutable';
import createAlertMessageModalReducer from 'react/api/reducers/alertMessageModal';
import routeSummaryActions from 'react/api/actions/routeSummary';

const modalActionsSubReducer = createAlertMessageModalReducer(
  routeSummaryActions.actions.alertMessageModal
);
const missingDriverModalSubReducer = createAlertMessageModalReducer(
  routeSummaryActions.actions.missingDriverModal
);

const assignDriverModalSubReducer = createAlertMessageModalReducer(
  routeSummaryActions.actions.assignDriverModal
);

const initialState = new Map({});

const loadSubmodules = (state, action) =>
  state.merge({
    alertMessageModal: modalActionsSubReducer(
      state.get('alertMessageModal'),
      action
    ),
    missingDriverModal: missingDriverModalSubReducer(
      state.get('missingDriverModal'),
      action
    ),
    assignDriverModal: assignDriverModalSubReducer(
      state.get('assignDriverModal'),
      action
    )
  });

// eslint-disable-next-line default-param-last
const reducer = (previousState = initialState, action) => {
  const state = loadSubmodules(previousState, action);
  if (
    action.type === routeSummaryActions.actions.missingDriverModal.OPEN_MODAL
  ) {
    return state.merge({
      ...action.payload
    });
  }
  if (action.type === routeSummaryActions.actions.assignDriverModal.CLOSE_MODAL
    || action.type === routeSummaryActions.actions.resetStopCandidate
  ) {
    return state.merge({
      stopCandidate: null,
    });
  }
  return state;
};

export default reducer;
